enum PlatformUsedTypeEnum
{
    APP = 'APP',
    WEB = 'WEB',
}

export default PlatformUsedTypeEnum;
